import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';
import { OrganizationUserRole } from '../../enums/organization-user-roles.enum';

@Component({
    selector: 'organization-role-filter-drop-down',
    templateUrl: './role-filter-drop-down.component.html',
    styleUrls: ['./role-filter-drop-down.component.scss'],
})
export class OrganizationRoleFilterDropDownComponent {
    @Input() selectedRoles: OrganizationUserRole[] = [];
    @Output() roleChange = new EventEmitter<OrganizationUserRole[]>();

    openedFlyout = false;
    @Input() rightAlignment: boolean = false;
    flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    statusOptions = [
        { label: 'Admin', value: OrganizationUserRole.ADMIN },
        { label: 'User', value: OrganizationUserRole.USER },
    ];
    @Input() singleSelection = false;

    isFilterActive: boolean = this.selectedRoles.length > 0;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedRoles']) {
            this.isFilterActive = this.selectedRoles && this.selectedRoles.length > 0;
        }
    }

    toggleRoleSelection(value: OrganizationUserRole): void {
        if (this.singleSelection) {
            this.selectedRoles = [value];
            this.applyFilter();
            return;
        }

        const isCurrentlySelected = this.selectedRoles.includes(value);
        this.onRoleSelection(value, !isCurrentlySelected);
    }

    onRoleSelection(value: OrganizationUserRole, checked: boolean) {
        if (this.singleSelection) {
            this.selectedRoles = [];
            this.selectedRoles.push(value);
            this.applyFilter();
            return;
        }

        if (checked) {
            this.selectedRoles.push(value);
        } else {
            this.selectedRoles = this.selectedRoles.filter((v) => v !== value);
        }
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;

        if (!buttonElement) return;

        const rect = buttonElement.getBoundingClientRect();

        this.flyoutPosition = {
            top: rect.bottom + 8,
            right: rect.right,
            left: rect.left,
        };

        const diffrence = rect.left - rect.right;

        if (this.rightAlignment) {
            this.flyoutPosition.left += diffrence;
        }

        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    applyFilter(): void {
        this.isFilterActive = this.selectedRoles.length > 0;
        this.closeFlyout();
        this.roleChange.emit(this.selectedRoles);
    }

    clearFilter(): void {
        this.selectedRoles = [];
        this.isFilterActive = false;
        this.closeFlyout();
        this.roleChange.emit(this.selectedRoles);
    }
}
